function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillOpacity: ".54",
  d: "M12.029 3.132a2.277 2.277 0 012.256 2.257 2.257 2.257 0 11-2.256-2.257zm0 3.37a1.1 1.1 0 001.084-1.084 1.1 1.1 0 00-1.084-1.084c-.586 0-1.084.469-1.084 1.084 0 .586.469 1.084 1.084 1.084zM14.549.7c.586 0 1.143.205 1.524.615.41.41.645.967.615 1.553l-.146 4.513a3.185 3.185 0 01-.938 2.052L9.07 15.967a2.37 2.37 0 01-1.729.733c-.615 0-1.26-.264-1.729-.733l-4.16-4.16a2.458 2.458 0 010-3.488l6.534-6.535a3.247 3.247 0 012.051-.937L14.55.7zm.85 6.593l.117-4.454a.928.928 0 00-.264-.674.926.926 0 00-.674-.264l-4.512.147c-.47.03-.909.234-1.26.586L2.27 9.17a1.292 1.292 0 000 1.817l4.161 4.16c.498.5 1.319.5 1.817 0l6.564-6.563c.352-.352.557-.791.586-1.29z"
})));